<template>
<div>
    <div>
        <p class="text-center text-3xl color1 mt-2" style="word-spacing: 5px;"><i class="fa-solid fa-feather"></i> Yo me Autovaluo</p>
        <p v-if="esDocente" class="color1 text-2xl text-center mt-3">Rúbrica de {{ObjectEvaluacion.estudiante}}</p>
        <vs-divider></vs-divider>
        <vs-row>
            <vs-col vs-w="6" vs-xs="12">
                <p class="color1 mt-2"><i class="fa-solid fa-circle-exclamation"></i> Seleccione como usted considere:</p>
            </vs-col>
            <vs-col vs-w="6" vs-xs="12">
                <div class="mt-2 mb-3 text-right">
                    <p class="mr-3"><b class="color1">Puntos: </b> </p><br>
                    <h2 v-if="ifestudiante == 0" class="color1"><span class="bg-calificacion mr-2">{{ ObjectEvaluacion.evaluacion[0].rubrica_calificacion }}</span></h2>
                    <h2 v-if="ifestudiante == 1" class="color1"><span class="bg-calificacion mr-2">{{ puntajeCalificacion }}</span></h2>
                </div>
            </vs-col>
        </vs-row>
        <div class="vx-row mt-5">
            <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-full mb-6">
                <div class="vx-row" v-for="(item,key) in arrayQuestionsRubrica" :key="key">
                    <div class="vx-col w-full mb-6">
                        <div class="flex bg1" style="justify-content: space-between;">
                            <div>
                                <p class="bg1 titulo">Pregunta {{ key + 1 }}</p>
                            </div>
                            <div>
                                <!--Caritas-->
                                <div class="flex-container" v-if="item.id_subnivel ==1">
                                    <div class="flex-item" v-for="n in item.puntaje" :key="n">
                                        <img width="50px" :src="require('@/assets/images/evaluacion/elemental.svg')" alt="elemental">
                                    </div>
                                </div>
                                <!--Estrellas-->
                                <div class="flex-container" v-if="item.id_subnivel ==2">
                                    <div class="flex-item" v-for="n in item.puntaje" :key="n">
                                        <img :src="mySVGMedio" width="50" />
                                    </div>
                                </div>
                                <div v-if="item.id_subnivel ==3">
                                    <p class="bg1 titulo">{{ item.puntaje }} pts</p>
                                </div>
                            </div>
                        </div>
                        <h5 class="mt-5 ml-2" style="font-weight: 400;">{{ item.indicador }}</h5>
                        <!--opciones-->
                        <br>
                        <vs-divider></vs-divider>
                        <ul class="centerx">
                            <li class="my-3">
                                <vs-checkbox disabled v-model="item.opc1" color="success">{{ item.opcion1 }}</vs-checkbox>
                            </li>
                            <li class="my-3">
                                <vs-checkbox disabled v-model="item.opc2" color="success">{{ item.opcion2 }}</vs-checkbox>
                            </li>
                            <li class="my-3">
                                <vs-checkbox disabled v-model="item.opc3" color="success">{{ item.opcion3 }}</vs-checkbox>
                            </li>
                            <li class="my-3">
                                <vs-checkbox disabled v-model="item.opc4" color="success">{{ item.opcion4 }}</vs-checkbox>
                            </li>
                        </ul>
                    </div>
                </div>
                <vs-divider></vs-divider>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    data() {
        return {
            usuario: [],
            arrayQuestionsRubrica: [],
            arraySend: [],
            mySVGElemental: require('../../../../assets/images/evaluacion/elemental.svg'),
            mySVGMedio: require('../../../../assets/images/evaluacion/medio.svg'),
            esDocente:'',
        }
    },
    props: {
        arrayPreguntasRubrica: {
            type: Array,
            default: function () {
                return []
            }
        },
        ObjectEvaluacion: {
            type: Object,
            default: function () {
                return {}
            }
        },
        ifestudiante: {
            type: Number,
            default: 0,
        },
        puntajeCalificacion: {
            type: Number,
            default: 0,
        }
    },
    created() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0];
        if(me.usuario.id_group == 6) {
            me.esDocente = true;
        }else{
            me.esDocente = false;
        }
        console.log()
    },
    mounted() {
        let me = this
        me.arrayQuestionsRubrica = me.arrayPreguntasRubrica
        //si opc1 es 0 es false y si es 1 es true
        //si opc2 es 0 es false y si es 1 es true
        //si opc3 es 0 es false y si es 1 es true
        //si opc4 es 0 es false y si es 1 es true
        me.arrayQuestionsRubrica.forEach(p => {
            if (p.opc1 == 1) {
                p.opc1 = true
            } else {
                p.opc1 = false
            }
            if (p.opc2 == 1) {
                p.opc2 = true
            } else {
                p.opc2 = false
            }
            if (p.opc3 == 1) {
                p.opc3 = true
            } else {
                p.opc3 = false
            }
            if (p.opc4 == 1) {
                p.opc4 = true
            } else {
                p.opc4 = false
            }
        });
    },
    methods: {

    }
}
</script>

<style scoped>
.color1 {
    color: #2F68AD;
}

.titulo {
    font-size: 18px;
    color: #19467c;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
}

.tamanio1 {
    font-size: 11px;
}

.bg1 {
    background: #f1f2f3;
    padding: 8px;
}

.reloj {
    font-size: 16px;
    color: #2F68AD;
    text-shadow: #e3e5e7 1px 1px 1px;
    padding: 5px;
}

/*ESTILOS PUNTOS*/
.flex-container {
    display: flex;
}

.flex-item {
    /* Opcional: Añade margen entre los elementos */
    margin-right: 10px;
}

.bg-calificacion {
    background-color: rgba(var(--vs-white1), 1) !important;
    border-radius: 10px;
    padding: 8px 6px;
    /* background-color: red */
}
</style>
